import type { StoreApi, UseBoundStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface PortfolioAppUpsellDismissalState {
  dismissed: boolean;
  dismiss: () => void;
}

export const usePortfolioAppUpsellDismissalStore: UseBoundStore<
  StoreApi<PortfolioAppUpsellDismissalState>
> = createTrackedStore<PortfolioAppUpsellDismissalState>('usePortfolioAppUpsellDismissalStore')(
  persist(
    (set) => ({
      dismissed: false,
      dismiss: (): void => {
        set({ dismissed: true });
      },
    }),
    {
      name: 'morfi-portfolio-app-upsell-dismissed',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
